(function(){
"use strict";
var ROOT = document.getElementById("ce-sr2");
if (!ROOT || ROOT.getAttribute("data-ready")) return;
ROOT.setAttribute("data-ready", "1");
var D = window.CE_SR2_DATA || {};
var UI=D.UI, MOD=D.MOD, AX=D.AX, has=D.has, Q=D.Q, QI=D.QI, PAT=D.PAT, ROLE=D.ROLE, WHEN=D.WHEN, EO=D.EO, EO_SWAP=D.EO_SWAP,
    CONCERN_PAT=D.CONCERN_PAT, SAFETY=D.SAFETY, NOTES=D.NOTES, CAUTION=D.CAUTION, TRIG=D.TRIG;
if (!UI || !PAT) return;
var ENDPOINT = ROOT.getAttribute("data-endpoint") || "";
var FR = window.CE_SR2_FR || null;
/* Live product data from Liquid, keyed by handle. Names are curated short names. */
var NAMES = {"acne_oil": "Acne Saver Cleanse Oil", "acne_gel": "Acne Saver Cleanse Gel", "tcg": "Therapeutic Cleanse Gel", "cleanse_eo": "Therapeutic Cleanse Gel EO Free", "toil": "Therapeutic Treatment Oil", "toil_eo": "Therapeutic Treatment Oil EO Free", "fluid": "Clarity Epidermal Tone Perfecting Fluid", "clarity": "Clarity Tone Perfecting Serum", "emulsion": "Clarity Tone Perfecting Emulsion", "luminous": "Luminous Pure Brightening Serum", "golden_dew": "Golden Dew Dual Action Vitamin C Serum", "shield": "Shield Super Antioxidant Serum", "eclipse": "Eclipse Rejuvenating Serum", "twilight": "Twilight Rejuvenating Night Serum", "moonlight": "Moonlight Renewal Serum", "oasis": "Oasis Super Hydrating Serum", "green": "GREEN Super Soothing Serum", "bob_serum": "Beauty of Balance Probiotic Boost Serum", "bob_cream": "Beauty of Balance Probiotic Boost Cream", "acne_serum": "Acne Saver Radiance Exfoliant Serum", "aurora": "Aurora 32 Cellular Radiance Renewal Oil", "gel_masque": "Therapeutic Hydrating Gel Masque", "lipid_masque": "Therapeutic Lipid Masque", "seaweed25": "Seaweed Silk Powder Exfoliant 0.25", "seaweed5": "Seaweed Silk Powder Exfoliant 0.5"};
var HANDLES = {"acne_oil": "acne-saver-cleanse-oil", "acne_gel": "acne-saver-cleanse-gel", "tcg": "therapeutic-cleanse-gel", "cleanse_eo": "therapeutic-cleanse-gel-eo-free", "toil": "therapeutic-treatment-oil", "toil_eo": "therapeutic-treatment-oil-eo-free", "fluid": "clarity-epidermal-tone-perfecting-fluid", "clarity": "clarity-timeless-anti-aging-tone-perfecting-serum", "emulsion": "clarity-tone-perfecting-emulsion", "luminous": "luminous-timeless-anti-aging-pure-brightening-serum", "golden_dew": "golden-dew-timeless-anti-aging-dual-action-vitamin-c-serum", "shield": "shield-age-regressing-super-antioxidant-serum", "eclipse": "eclipse-age-regressing-rejuvenating-serum", "twilight": "twilight-age-regressing-rejuvenating-night-serum", "moonlight": "moonlight-timeless-anti-aging-renewal-serum", "oasis": "oasis-age-regressing-super-hydrating-serum", "green": "green-age-regressing-super-soothing-serum", "bob_serum": "beauty-of-balance-timeless-anti-aging-probiotic-boost-serum", "bob_cream": "beauty-of-balance-timeless-anti-aging-probiotic-boost-cream", "acne_serum": "acne-saver-timeless-anti-aging-radiance-exfoliant-serum", "aurora": "aurora-32-advanced-cellular-radiance-renewal-oil", "gel_masque": "therapeutic-hydrating-gel-masque", "lipid_masque": "therapeutic-lipid-masque", "seaweed25": "seaweed-silk-peptide-powder-exfoliant-formula-0-25", "seaweed5": "seaweed-silk-peptide-powder-exfoliant-formula-0-5"};
var LIVE = {};
try { LIVE = JSON.parse(document.getElementById("ce-sr2-products").textContent); } catch (e) {}
var PRODUCTS = {};
Object.keys(HANDLES).forEach(function(k){
 var p = LIVE[HANDLES[k]];
 if (p) PRODUCTS[k] = { name: NAMES[k], url: p.url, price: p.price, available: p.available, img: p.img };
});
/* ---------- state ---------- */
var S = { lang:"en", mode:"self", step:-1, A:{}, optOut:false, code:"", saveState:"" };
function store(k,v){ try{ if(v===undefined) return localStorage.getItem(k); localStorage.setItem(k,v); }catch(e){ return null; } }
var T = function(k){ return UI[S.lang][k]; };
var L = function(o){ return o ? (o[S.lang]!==undefined ? o[S.lang] : o.en) : ""; };
var $view = document.getElementById("ce-sr2-view");
function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }

/* which questions to ask, recomputed after every answer */
function plan(){
 var A=S.A, out=[], pro=S.mode==="pro";
 var conc = (A.c_concern||[]).slice();
 var main = conc.length===1 ? conc[0] : A.c_main;
 if (has(A,"c_sting","often")||has(A,"c_sting","used")) if (conc.indexOf("sens")<0) conc.push("sens");
 /* answers in the core can open a module the client did not pick */
 if ((has(A,"c_red","comes")||has(A,"c_red","always")) && conc.indexOf("red")<0) conc.push("red");
 if ((has(A,"c_mark","brown")||has(A,"c_mark","long")) && conc.indexOf("pig")<0) conc.push("pig");
 Q.forEach(function(q){ if(q.mod!=="core") return;
  if (q.id==="c_main" && (A.c_concern||[]).length<2) return;
  out.push(q.id); });
 var order = main ? [main].concat(conc.filter(function(c){return c!==main;})) : conc;
 order.forEach(function(m){
  Q.forEach(function(q){
   if (q.mod!==m) return;
   if (q.pro && !pro) return;
   if (m!==main && !q.core) return;      /* secondary concerns: core questions only */
   if (q.when && !q.when(A)) return;
   out.push(q.id);
  });
 });
 if (pro) Q.forEach(function(q){ if((q.mod==="hist"||q.mod==="obs") && (!q.when||q.when(A))) out.push(q.id); });
 out.push("flags");
 return out;
}
function optsFor(q){
 if (q.id!=="c_main") return q.o;
 var src=QI.c_concern.o;
 return src.filter(function(o){ return (S.A.c_concern||[]).indexOf(o[0])>-1; });
}

/* ---------- scoring ---------- */
function score(){
 var A=S.A, ids=plan(), sum={}, max={}, tags={}, drivers=[];
 Object.keys(AX).forEach(function(k){ sum[k]=0; max[k]=0; });
 ids.forEach(function(id){
  var q=QI[id]; if(!q||q.dyn||q.flagQ) return;
  /* Evidence questions (multi choice, history, observation, modifiers) only count when they find something,
     so asking more of them never dilutes a score. Single choice questions count their full range. */
  var evidence = q.multi || q.bonus || q.mod==="hist" || q.mod==="obs";
  if (!evidence){
   var pos={};
   q.o.forEach(function(o){ var s=o[3]||{}; Object.keys(s).forEach(function(k){ if(s[k]>0) pos[k]=Math.max(pos[k]||0,s[k]); }); });
   Object.keys(pos).forEach(function(k){ max[k]+=pos[k]; });
  }
  var picked=[].concat(A[id]===undefined?[]:A[id]);
  q.o.forEach(function(o){ if(picked.indexOf(o[0])<0) return;
   var s=o[3]||{}; Object.keys(s).forEach(function(k){ sum[k]+=s[k]; if(evidence && s[k]>0) max[k]+=s[k]; if(s[k]>0) drivers.push({ax:k,v:s[k],q:q,o:o}); });
   if(o[4]) tags[o[4]]=1; });
 });
 var sc={}; Object.keys(AX).forEach(function(k){ sc[k]=Math.max(0,Math.min(100,Math.round(100*sum[k]/Math.max(max[k],6)))); });
 var flags=[].concat(A.flags||[]); if(tags.weep && flags.indexOf("weeping")<0) flags.push("weeping");
 return {sc:sc,tags:tags,drivers:drivers,flags:flags};
}
function route(R){
 var s=R.sc, t=R.tags, A=S.A, hold=[];
 var older = A.c_age==="40-54" || A.c_age==="55+";
 if (s.red>=65 || (t.dx_rosacea && s.red>=35)) hold.push("flush");
 if (s.perio>=60) hold.push("perio");
 if (s.itch>=60) hold.push("itch");
 if (s.barrier>=55 && s.react>=50) hold.push("barrier");
 if (s.seb>=60) hold.push("seb");
 if (s.oil>=55 && s.react>=45) hold.push("oilyreact");
 if (s.acne>=50 || (s.oil>=65 && s.hyd<50)) hold.push("oily");
 if (s.oil>=50 && s.hyd>=50) hold.push("oilydehyd");
 if (s.uv>=50 && !t.dx_rosacea) hold.push("sun");
 if (s.pig>=55) hold.push("pig");
 if (s.age>=50) hold.push(t.firm || (older && s.age>=67) ? "firm" : "lines");
 if (s.hyd>=50 && s.lip>=50) hold.push("drydepleted");
 else if (s.hyd>=50) hold.push("dehyd");
 else if (s.lip>=50) hold.push("lipid");
 if (!hold.length) hold.push("settled");
 /* the client's own main concern leads, unless a pattern that changes safety is present */
 var main=(A.c_concern||[]).length===1?A.c_concern[0]:A.c_main;
 if (main && SAFETY.indexOf(hold[0])<0){
  var want=(CONCERN_PAT[main]||[]).filter(function(p){return hold.indexOf(p)>-1;})[0];
  if (want){ hold.splice(hold.indexOf(want),1); hold.unshift(want); }
 }
 return hold;
}

/* The routine starts from the lead pattern's products, then adds what the other high axes need,
   one product per slot, then makes it safe for this skin. That is where the combinations come from. */
function routine(hold,R){
 var s=R.sc, t=R.tags, A=S.A, lead=hold[0];
 var young = A.c_age==="<20" || A.c_age==="20-29";
 var keys=PAT[lead].rx.slice();
 var add=function(k){ if (keys.indexOf(k)<0) keys.push(k); };
 if (s.hyd>=50) add("oasis");
 if (s.lip>=50){ add("eclipse"); add("lipid_masque"); }
 if (s.pig>=50) add("clarity");
 if (s.red>=50 || s.react>=45) add("clarity");
 if (s.age>=50) add(t.firm ? "twilight" : "eclipse");
 if (s.acne>=50) add("acne_serum");
 /* GREEN is for skin that reddens and tans in the sun, not for vascular flushing and not for stinging skin */
 if (s.uv>=50 && lead!=="flush" && !t.dx_rosacea) add("green");
 /* sebum and congestion: powder exfoliant, the stronger one only for acid-used, non reactive oily skin */
 if (s.acne>=40 || s.oil>=55 || s.seb>=50) add(s.oil>=65 && (A.c_active==="weekly"||A.c_active==="most") ? "seaweed5" : "seaweed25");
 if (hold[1]) PAT[hold[1]].rx.forEach(function(k){ if (ROLE[k] && ROLE[k][0]>=4) add(k); });

 /* every routine starts with a cleanser */
 var oilyish = s.oil>=50 || s.acne>=40 || s.seb>=50;
 var stings = A.c_sting==="often" || A.c_sting==="used";
 if (!keys.some(function(k){ return ROLE[k] && ROLE[k][0]===2; })) keys.unshift(oilyish||stings ? "acne_gel" : "tcg");

 if (young && SAFETY.indexOf(lead)<0) add("moonlight");

 /* make it safe */
 var reactive = s.react>=45 || t.frag || t.neuro || stings || SAFETY.indexOf(lead)>-1;
 var noRetinol = reactive || t.preg || young || A.g_ret==="irritated" || t.iso;
 keys = keys.map(function(k){
  if ((reactive || t.frag) && EO.indexOf(k)>-1) return EO_SWAP[k];
  if (reactive && (k==="green" || k==="moonlight")) return "clarity";   /* plant extracts: not on stinging skin */
  if (reactive && (k==="seaweed5" || k==="seaweed25")) return null;
  if (young && !reactive && (k==="eclipse" || k==="twilight")) return "moonlight";
  if (k==="twilight" && noRetinol) return "eclipse";
  return k;
 }).filter(Boolean);
 if (lead==="barrier" || lead==="itch" || lead==="perio")      /* no night actives while the skin settles */
  keys = keys.filter(function(k){ return ROLE[k][0]!==5; });
 if (reactive && lead!=="oilyreact") keys = keys.filter(function(k){ return k!=="acne_serum"; });

 /* one product per slot, except serums (step 4) and masks, where two can sit together */
 var seen={}, used={}, out=[];
 keys.forEach(function(k){
  var r=ROLE[k], p=PRODUCTS[k];
  if (!r || !p || !p.available || seen[k]) return;
  var cap = (r[0]===4 || r[0]===9) ? 2 : 1;
  if ((used[r[0]]||0)>=cap) return;
  seen[k]=1; used[r[0]]=(used[r[0]]||0)+1;
  out.push({k:k,p:p,step:r[0],when:r[1],role:r[2]});
 });
 out.sort(function(a,b){ return a.step-b.step; });
 return out.slice(0,7);
}

/* ---------- rendering ---------- */
function setProg(){
 var bar=document.getElementById("ce-sr2-prog");
 bar.parentNode.style.visibility = S.step<0 ? "hidden" : "visible";
 if (S.step<0){ bar.style.width="0"; return; }
 if (S.step>=plan().length){ bar.style.width="100%"; return; }
 bar.style.width = Math.round(100*S.step/plan().length)+"%";
}
function paintShell(){
 document.getElementById("ce-sr2").setAttribute("lang",S.lang);

 ROOT.querySelectorAll(".langs button").forEach(function(b){ b.setAttribute("aria-pressed", String(b.dataset.lang===S.lang)); });
 document.getElementById("ce-sr2-mark").innerHTML = "Complete Elixir <span>The Skin Read"+(S.mode==="pro"?' <em class="pro-tag">Pro</em>':"")+"</span>";
 document.getElementById("ce-sr2-fine").textContent = T("fine");
}
function render(){
 paintShell(); setProg();
 if (S.step<0) return intro();
 var ids=plan();
 if (S.step>=ids.length) return result();
 question(QI[ids[S.step]], S.step, ids.length);
}
function intro(){
 var pro=S.mode==="pro", nm=store("sr.pro.name")||"", cl=store("sr.pro.clinic")||"";
 var h='<section class="intro">'+
  '<h1>The Skin Read</h1>'+
  '<div class="seg" role="group" aria-label="'+esc(T("modeLabel"))+'">'+
   '<button type="button" data-mode="self" aria-pressed="'+(!pro)+'">'+esc(T("modeSelf"))+'</button>'+
   '<button type="button" data-mode="pro" aria-pressed="'+pro+'">'+esc(T("modePro"))+'</button></div>'+
  '<p class="lede">'+esc(T(pro?"introLedePro":"introLede"))+'</p>';
 if (pro){
  if (nm && !S.editWho) h+='<div class="whoset"><span>'+esc(nm)+(cl?' · '+esc(cl):"")+'</span><button type="button" class="link" id="ce-sr2-who">'+esc(T("change"))+'</button></div>';
  else h+='<div class="who"><input id="ce-sr2-you" autocomplete="name" placeholder="'+esc(T("you"))+'" aria-label="'+esc(T("you"))+'" value="'+esc(nm)+'">'+
          '<input id="ce-sr2-clinic" autocomplete="organization" placeholder="'+esc(T("clinic"))+'" aria-label="'+esc(T("clinic"))+'" value="'+esc(cl)+'"></div>';
 }
 h+='<button class="cta" id="ce-sr2-go" type="button">'+esc(T(pro?"startPro":"start"))+'</button>'+
    '<p class="meta">'+esc(T(pro?"metaPro":"meta"))+'</p>'+
    /* the saving notice only appears once a receiver is connected, so it never promises something that is not happening */
    (ENDPOINT ? '<div class="save"><span>'+esc(T(pro?"saveNotePro":"saveNote"))+'</span><button type="button" class="tog" id="ce-sr2-opt" aria-pressed="'+S.optOut+'">'+esc(T("dontSave"))+'</button></div>' : '')+
    '</section>';
 $view.innerHTML=h;
 var opt=document.getElementById("ce-sr2-opt");
 if (opt) opt.onclick=function(){ S.optOut=!S.optOut; opt.setAttribute("aria-pressed",String(S.optOut)); };
 $view.querySelectorAll(".seg button").forEach(function(b){ b.onclick=function(){
  if (S.mode===b.dataset.mode) return;
  S.mode=b.dataset.mode; store("sr.mode",S.mode); S.optOut=false; render(); }; });
 var who=document.getElementById("ce-sr2-who"); if (who) who.onclick=function(){ S.editWho=true; render(); };
 document.getElementById("ce-sr2-go").onclick=function(){
  var you=document.getElementById("ce-sr2-you");
  if (you){ store("sr.pro.name", you.value.trim()); store("sr.pro.clinic", document.getElementById("ce-sr2-clinic").value.trim()); }
  S.editWho=false; S.A={}; S.step=0; S.code=""; S.saveState=""; render(); toTop();
 };
}
function toTop(){ var w=document.getElementById("ce-sr2"); var y=w.getBoundingClientRect().top+window.scrollY; if (window.scrollY>y) window.scrollTo({top:y}); }
function question(q, i, n){
 var opts=optsFor(q), cur=S.A[q.id], multi=!!q.multi;
 var h='<section class="q" aria-live="polite">'+
  '<div class="qtop"><button class="back" type="button" id="ce-sr2-back">← '+esc(T("back"))+'</button>'+
  '<span class="count">'+esc(L(MOD[q.mod]))+' · '+(i+1)+T("of")+n+'</span></div>'+
  '<h2>'+esc(L(q))+'</h2>'+(q.sub?'<p class="sub">'+esc(L(q.sub))+'</p>':"")+
  '<div class="opts" role="'+(multi?"group":"radiogroup")+'">';
 opts.forEach(function(o){
  var on = multi ? (cur||[]).indexOf(o[0])>-1 : cur===o[0];
  h+='<button type="button" class="opt'+(multi?" multi":"")+'" data-v="'+esc(o[0])+'" aria-pressed="'+on+'"><span class="box"></span><span>'+esc(OT(o))+'</span></button>';
 });
 h+='</div>';
 if (multi){
  var last = i===n-1;
  h+='<div class="next"><button class="cta" type="button" id="ce-sr2-next">'+esc(last?T("seeResult"):T("next"))+'</button></div>';
 }
 h+='</section>';
 $view.innerHTML=h;
 var nextBtn=document.getElementById("ce-sr2-next");
 function syncNext(){ if(!nextBtn) return; var need=q.id==="c_concern"; nextBtn.disabled = need && !(S.A[q.id]||[]).length; }
 syncNext();
 $view.querySelectorAll(".opt").forEach(function(b){
  b.onclick=function(){
   var v=b.dataset.v;
   if (multi){
    var arr=(S.A[q.id]||[]).slice(), k=arr.indexOf(v);
    if (k>-1) arr.splice(k,1); else {
     if (q.excl && q.excl.indexOf(v)>-1) arr=[];
     else if (q.excl) arr=arr.filter(function(x){return q.excl.indexOf(x)<0;});
     arr.push(v);
    }
    S.A[q.id]=arr;
    if (q.id==="c_concern" && S.A.c_main && arr.indexOf(S.A.c_main)<0) delete S.A.c_main;
    $view.querySelectorAll(".opt").forEach(function(x){ x.setAttribute("aria-pressed", String(arr.indexOf(x.dataset.v)>-1)); });
    syncNext();
   } else {
    S.A[q.id]=v;
    $view.querySelectorAll(".opt").forEach(function(x){ x.setAttribute("aria-pressed", String(x.dataset.v===v)); });
    setTimeout(function(){ S.step++; render(); toTop(); }, 180);
   }
  };
 });
 if (nextBtn) nextBtn.onclick=function(){ if(!S.A[q.id]) S.A[q.id]=[]; S.step++; render(); toTop(); };
 document.getElementById("ce-sr2-back").onclick=function(){ S.step--; render(); toTop(); };
}

function dialHTML(k,v,compact){
 var a=L(AX[k]);
 return '<div class="dial"><div class="top"><b>'+esc(a[0])+'</b><span>'+v+'</span></div>'+
  '<div class="track"><i style="width:'+v+'%"></i></div>'+
  (compact?"":'<div class="poles"><span>'+esc(a[1])+'</span><span>'+esc(a[2])+'</span></div>')+'</div>';
}
function listHTML(cls,title,items){
 return '<div class="list '+cls+'"><h4>'+esc(title)+'</h4><ul>'+items.map(function(x){return "<li>"+esc(x)+"</li>";}).join("")+'</ul></div>';
}
function newCode(){
 var c="ABCDEFGHJKMNPQRSTUVWXYZ23456789", s="";
 for (var i=0;i<6;i++) s+=c[Math.floor(Math.random()*c.length)];
 var d=new Date(); return "SR-"+String(d.getFullYear()).slice(2)+String(d.getMonth()+1).padStart(2,"0")+"-"+s;
}

function result(){
 var pro=S.mode==="pro", R=score(), hold=route(R), key=hold[0], P=L(PAT[key]);
 if (!S.code) S.code=newCode();
 var h='<section class="res">';

 /* refer */
 if (R.flags.length){
  var fq=QI.flags;
  h+='<div class="refer" role="alert"><h3>'+esc(T(pro?"referPro":"referTitle"))+'</h3><p style="margin:0;font-size:15px">'+esc(T(pro?"referLeadPro":"referLead"))+'</p><ul>'+
   R.flags.map(function(f){ var o=fq.o.filter(function(x){return x[0]===f;})[0]; return o?"<li>"+esc(OT(o))+"</li>":""; }).join("")+'</ul></div>';
 }
 /* cautions for the room */
 var caut = pro ? Object.keys(CAUTION).filter(function(t){ return R.tags[t] || (t==="papules" && R.tags.papules && R.sc.red>=40); }) : [];
 if (caut.length){
  h+='<div class="sec"><h3>'+esc(T("cautions"))+'</h3><div class="notes">'+caut.map(function(t){ return '<div class="note"><p style="color:var(--ink)">'+esc(L(CAUTION[t]))+'</p></div>'; }).join("")+'</div></div>';
 }

 /* name */
 h+='<div class="name"><div class="eyebrow">'+esc(T("yourPattern"))+'</div><h1>'+esc(P.name)+'</h1><p class="line">'+esc(P.line)+'</p>'+
    (hold[1]?'<div class="second">'+esc(T("alsoShows"))+esc(L(PAT[hold[1]]).name)+'</div>':"")+'</div>';

 /* signals */
 var keys=Object.keys(AX).filter(function(k){return R.sc[k]>0;}).sort(function(a,b){return R.sc[b]-R.sc[a];});
 if (pro){
  h+='<div class="sec"><h3>'+esc(T("dialsPro"))+'</h3><div class="dials compact">'+keys.map(function(k){return dialHTML(k,R.sc[k],true);}).join("")+'</div></div>';
  var dr=R.drivers.filter(function(d){return PAT[key].axes.indexOf(d.ax)>-1;}).sort(function(a,b){return b.v-a.v;});
  var seenO={}, lines=[];
  dr.forEach(function(d){ var id=d.q.id+d.o[0]; if(seenO[id]||lines.length>=5) return; seenO[id]=1; lines.push(d); });
  if (lines.length) h+='<div class="sec"><h3>'+esc(T("why"))+'</h3><ul class="drivers">'+lines.map(function(d){
    var a=OT(d.o);
    if (a.length<10) a=L(d.q).replace(/[:?]\s*$/,"")+": "+a;   /* "Yes" alone means nothing out of context */
    return '<li><span>'+esc(L(MOD[d.q.mod]))+'</span>'+esc(a)+'</li>'; }).join("")+'</ul></div>';
  if (plan().indexOf("n_trig")>-1){
   h+='<div class="sec"><h3>'+esc(T("triggers"))+'</h3><div class="trig">'+TRIG.map(function(t){ return '<span class="'+(R.tags[t[0]]?"on":"")+'">'+esc(L(t[1]))+'</span>'; }).join("")+'</div></div>';
  }
 } else {
  h+='<div class="sec"><h3>'+esc(T("whatWeSee"))+'</h3><div class="dials">'+keys.slice(0,3).map(function(k){return dialHTML(k,R.sc[k]);}).join("")+'</div></div>';
 }

 h+='<div class="sec"><h3>'+esc(T(pro?"sayPro":"sayTitle"))+'</h3><p class="say">'+esc(P.say)+'</p></div>';
 if (pro) h+='<div class="sec"><h3>'+esc(T("inClinic"))+'</h3><div class="pair">'+listHTML("stop",T("avoid"),P.avoid)+listHTML("plain",T("focus"),P.focus)+'</div></div>';
 h+='<div class="sec"><h3>'+esc(T(pro?"homeCare":"homeCare"))+'</h3><div class="pair">'+listHTML("stop",T("stop"),P.stop)+listHTML("start",T("startDo"),P.start)+'</div></div>';
 h+='<div class="sec"><h3>'+esc(T("look"))+'</h3><div class="ings">'+P.ing.map(function(x){return "<span>"+esc(x)+"</span>";}).join("")+'</div></div>';

 var pr=routine(hold,R);
 if (pr.length) h+='<div class="sec"><h3>'+esc(T("products"))+'</h3><div class="prods'+(pr.length===4?" n4":"")+'">'+pr.map(function(x){
   return '<a class="prod" href="'+esc(x.p.url)+'" target="_blank" rel="noopener"><div class="ph"><img src="'+x.p.img+'" alt="" loading="lazy"></div>'+
    '<span class="role">'+esc(L(x.role))+'</span><span class="pn">'+esc(x.p.name)+'</span><span class="pp">$'+x.p.price+' · '+esc(L(WHEN[x.when]))+'</span></a>'; }).join("")+'</div></div>';

 var nk=Object.keys(NOTES).filter(function(t){return R.tags[t];});
 if (nk.length) h+='<div class="sec"><h3>'+esc(T("notes"))+'</h3><div class="notes">'+nk.map(function(t){ var n=L(NOTES[t]); return '<div class="note"><b>'+esc(n[0])+'</b><p>'+esc(n[1])+'</p></div>'; }).join("")+'</div></div>';

 h+='<div class="code"><span>'+esc(T("code"))+'<br>'+esc(T(pro?"codeHelpPro":"codeHelp"))+'</span><b>'+S.code+'</b></div>';
 h+='<div class="actions">'+(pro?'<button class="cta" type="button" id="ce-sr2-copy">'+esc(T("copy"))+'</button>':"")+
    '<button class="cta ghost" type="button" id="ce-sr2-again">'+esc(T(pro?"newC":"again"))+'</button>'+
    '<button class="saved" type="button" id="ce-sr2-saved" style="background:none;border:0;cursor:default"></button></div>';
 h+='</section>';
 $view.innerHTML=h;

 document.getElementById("ce-sr2-again").onclick=function(){ S.A={}; S.step=-1; S.code=""; S.saveState=""; S.optOut=false; render(); toTop(); };
 if (pro) document.getElementById("ce-sr2-copy").onclick=function(e){
  var txt=summary(R,hold), btn=e.currentTarget;
  var done=function(){ btn.textContent=T("copied"); setTimeout(function(){btn.textContent=T("copy");},1600); };
  if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done,function(){ fallbackCopy(txt); done(); }); else { fallbackCopy(txt); done(); }
 };
 save(R,hold);
}
function fallbackCopy(t){ var a=document.createElement("textarea"); a.value=t; document.body.appendChild(a); a.select(); try{document.execCommand("copy");}catch(e){} a.remove(); }

/* plain text summary, English or Korean, for the client card or a message */
function summary(R,hold){
 var P=L(PAT[hold[0]]), out=[];
 out.push("The Skin Read · "+S.code);
 out.push(P.name+(hold[1]?" (+ "+L(PAT[hold[1]]).name+")":""));
 if (R.flags.length) out.push("REFER: "+R.flags.join(", "));
 Object.keys(AX).filter(function(k){return R.sc[k]>0;}).sort(function(a,b){return R.sc[b]-R.sc[a];}).forEach(function(k){ out.push(L(AX[k])[0]+": "+R.sc[k]); });
 out.push(""); out.push(T("avoid")+": "+P.avoid.join("; "));
 out.push(T("stop")+": "+P.stop.join("; ")); out.push(T("startDo")+": "+P.start.join("; "));
 out.push(T("products")+": "+routine(hold,R).map(function(x){return L(x.role)+": "+x.p.name+" ("+L(WHEN[x.when])+")";}).join(", "));
 return out.join("\n");
}

/* ---------- saving ---------- */
function save(R,hold){
 var el=document.getElementById("ce-sr2-saved");
 function show(k,retry){ el.textContent=T(k); el.style.cursor=retry?"pointer":"default"; el.onclick=retry?function(){ S.saveState=""; save(R,hold); }:null; }
 if (S.optOut){ show("notSaved"); return; }
 if (!ENDPOINT){ el.textContent=""; return; }
 if (S.saveState==="saved"){ show("saved"); return; }
 show("saving");
 var pro=S.mode==="pro", d={
  code:S.code, mode:pro?"consultation":"self check", lang:S.lang, version:"2.0",
  esthetician:pro?(store("sr.pro.name")||""):"", clinic:pro?(store("sr.pro.clinic")||""):"",
  pattern:PAT[hold[0]].en.name, secondary:hold[1]?PAT[hold[1]].en.name:"",
  refer:R.flags.join("; "), tags:Object.keys(R.tags).join("; "),
  products:routine(hold,R).map(function(x){return x.p.name;}).join("; "),
  page:location.hostname
 };
 Object.keys(AX).forEach(function(k){ d["score_"+k]=R.sc[k]; });
 plan().forEach(function(id){ var v=S.A[id]; d[id]=Array.isArray(v)?v.join("; "):(v||""); });
 var body=new URLSearchParams(d);
 fetch(ENDPOINT,{method:"POST",mode:"no-cors",body:body})
  .then(function(){ S.saveState="saved"; show("saved"); })
  .catch(function(){ show("saveFail",true); });
}

/* ---------- boot ---------- */
/* option text in the current language */
function OT(o){ return S.lang==="ko" ? o[2] : (S.lang==="fr" && o.fr ? o.fr : o[1]); }
function mergeFR(){
 if (!FR) return;
 UI.fr = Object.assign({}, UI.en, FR.UI);
 Object.keys(MOD).forEach(function(k){ if (FR.MOD[k]) MOD[k].fr=FR.MOD[k]; });
 Object.keys(AX).forEach(function(k){ if (FR.AX[k]) AX[k].fr=FR.AX[k]; });
 Q.forEach(function(q){ var f=FR.Q[q.id]; if(!f) return; q.fr=f.q; if (q.sub && f.sub) q.sub.fr=f.sub;
  q.o.forEach(function(o,j){ if (f.o[j]) o.fr=f.o[j]; }); });
 Object.keys(PAT).forEach(function(k){ if (FR.PAT[k]) PAT[k].fr=Object.assign({}, PAT[k].en, FR.PAT[k]); });
 Object.keys(NOTES).forEach(function(k){ if (FR.NOTES[k]) NOTES[k].fr=FR.NOTES[k]; });
 Object.keys(CAUTION).forEach(function(k){ if (FR.CAUTION[k]) CAUTION[k].fr=FR.CAUTION[k]; });
 TRIG.forEach(function(x){ if (FR.TRIG[x[0]]) x[1].fr=FR.TRIG[x[0]]; });
 Object.keys(ROLE).forEach(function(k){ if (FR.ROLE[k]) ROLE[k][2].fr=FR.ROLE[k]; });
 Object.keys(WHEN).forEach(function(k){ if (FR.WHEN[k]) WHEN[k].fr=FR.WHEN[k]; });
}
mergeFR();
(function(){
 var qs=new URLSearchParams(location.search);
 var l=qs.get("lang")||store("sr.lang")||((navigator.language||"").toLowerCase().indexOf("ko")===0?"ko":"en");
 if (!qs.get("lang") && !store("sr.lang") && (navigator.language||"").toLowerCase().indexOf("fr")===0) l="fr";
 S.lang = UI[l]?l:"en";
 if (qs.get("mode")==="pro" || location.hash==="#pro" || store("sr.mode")==="pro") S.mode="pro";
 if (qs.get("mode")==="self") S.mode="self";
 ROOT.querySelectorAll(".langs button").forEach(function(b){
  b.onclick=function(){ S.lang=b.dataset.lang; store("sr.lang",S.lang); render(); };
 });
 render();
})();
window.__ceSR2={S:S,plan:plan,score:score,route:route,routine:routine,render:render,Q:Q,PAT:PAT,UI:UI,MOD:MOD,AX:AX,NOTES:NOTES,CAUTION:CAUTION,TRIG:TRIG,ROLE:ROLE,WHEN:WHEN};

})();
